module.exports = __webpack_public_path__ + "img/download.64d36276.svg";